<template>
    <div>
        <img class="papsi-icon" :src="getIcon(id)" :style="iconStyle" />
    </div>
</template>

<script>
import mixin from '@/mixins/controls.js';
export default {
    name: 'v-icon',
    mixins: [
        mixin
    ],
    props: {
        id: {
            type: String,
            default: ''
        },
        width: {
            type: Number,
            default: 24
        },
        height: {
            type: Number,
            default: 24
        }
    },
    computed: {
        iconStyle() {
            return {
                width: `${this.width}px` ,
                height:  `${this.height}px`,
            };
        }
    }
}
</script>

<style scoped>
</style>